(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-page"] && !Shopify.designMode) return;
  try {
    
  const initializePocoFaqPage = (scope = document) => {
    scope.querySelectorAll('[data-poco-faq-page]:not([data-faq-ready])').forEach((root) => {
      root.dataset.faqReady = 'true';
      const input = root.querySelector('[role="combobox"]');
      const suggestions = root.querySelector('[role="listbox"]');
      const clearButton = root.querySelector('.poco-faq-page__clear');
      const status = root.querySelector('.poco-faq-page__status');
      const empty = root.querySelector('[data-faq-empty]');
      const groups = [...root.querySelectorAll('[data-faq-group]')];
      const items = [...root.querySelectorAll('[data-faq-item]')];
      const normalize = (value) => value.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim();
      root.addEventListener('click', (event) => {
        if (event.target.closest('.poco-faq-page__clear, [data-faq-reset]')) {
          input.value = '';
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.focus();
        }
      });
      const records = items.map((item) => {
        const question = item.querySelector('[data-faq-question]').textContent.trim();
        const answer = item.querySelector('[data-faq-answer]').textContent.trim();
        const group = item.closest('[data-faq-group]');
        return {
          item,
          question,
          category: group.dataset.categoryLabel,
          questionSearch: normalize(question),
          search: normalize(`${question} ${answer} ${group.dataset.categoryLabel}`)
        };
      });
      let activeIndex = -1;
      let suggestedRecords = [];

      const closeSuggestions = () => {
        suggestions.hidden = true;
        suggestions.replaceChildren();
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
        activeIndex = -1;
        suggestedRecords = [];
      };

      const setActiveSuggestion = (nextIndex) => {
        const options = [...suggestions.querySelectorAll('[role="option"]')];
        if (!options.length) return;
        activeIndex = (nextIndex + options.length) % options.length;
        options.forEach((option, index) => option.setAttribute('aria-selected', String(index === activeIndex)));
        const activeOption = options[activeIndex];
        input.setAttribute('aria-activedescendant', activeOption.id);
        activeOption.scrollIntoView({ block: 'nearest' });
      };

      const selectRecord = (record) => {
        input.value = record.question;
        closeSuggestions();
        filterFaq();
        record.item.open = true;
        requestAnimationFrame(() => {
          record.item.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
          record.item.querySelector('summary').focus({ preventScroll: true });
        });
      };

      const renderSuggestions = (matches, query) => {
        closeSuggestions();
        if (query.length < 2 || !matches.length) return;
        suggestedRecords = [...matches]
          .sort((first, second) => {
            const firstScore = first.questionSearch.startsWith(query) ? 0 : first.questionSearch.includes(query) ? 1 : 2;
            const secondScore = second.questionSearch.startsWith(query) ? 0 : second.questionSearch.includes(query) ? 1 : 2;
            return firstScore - secondScore || first.question.localeCompare(second.question);
          })
          .slice(0, 6);
        const fragment = document.createDocumentFragment();
        suggestedRecords.forEach((record, index) => {
          const option = document.createElement('li');
          const question = document.createElement('span');
          const category = document.createElement('span');
          option.id = `${suggestions.id}-option-${index}`;
          option.className = 'poco-faq-page__suggestion';
          option.setAttribute('role', 'option');
          option.setAttribute('aria-selected', 'false');
          question.className = 'poco-faq-page__suggestion-question';
          category.className = 'poco-faq-page__suggestion-category';
          question.textContent = record.question;
          category.textContent = record.category;
          option.append(question, category);
          option.addEventListener('pointerdown', (event) => {
            event.preventDefault();
            selectRecord(record);
          });
          fragment.append(option);
        });
        suggestions.append(fragment);
        suggestions.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      };

      function filterFaq() {
        const query = normalize(input.value);
        const tokens = query.split(' ').filter(Boolean);
        const matches = records.filter((record) => tokens.every((token) => record.search.includes(token)));
        records.forEach((record) => {
          record.item.hidden = !matches.includes(record);
          if (record.item.hidden) record.item.open = false;
        });
        groups.forEach((group) => {
          group.hidden = !group.querySelector('[data-faq-item]:not([hidden])');
        });
        empty.hidden = matches.length > 0;
        clearButton.hidden = query.length === 0;
        const message = matches.length === 1 ? root.dataset.resultSingle : root.dataset.resultPlural;
        status.textContent = message.replace('__count__', String(matches.length));
        renderSuggestions(matches, query);
      }

      input.addEventListener('input', filterFaq);
      input.addEventListener('focus', filterFaq);
      input.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          setActiveSuggestion(activeIndex + 1);
        }
        if (event.key === 'ArrowUp') {
          event.preventDefault();
          setActiveSuggestion(activeIndex - 1);
        }
        if (event.key === 'Enter' && activeIndex >= 0) {
          event.preventDefault();
          selectRecord(suggestedRecords[activeIndex]);
        }
        if (event.key === 'Escape') closeSuggestions();
      });
      root.addEventListener('focusout', (event) => {
        if (!root.querySelector('.poco-faq-page__combobox').contains(event.relatedTarget)) closeSuggestions();
      });
      root.querySelectorAll('[data-faq-quick-question]').forEach((button) => {
        button.addEventListener('click', () => {
          const targetQuestion = normalize(button.dataset.faqQuickQuestion);
          const record = records.find((entry) => entry.questionSearch === targetQuestion);
          if (record) selectRecord(record);
        });
      });
      filterFaq();
      closeSuggestions();
    });
  };

  initializePocoFaqPage();
  document.addEventListener('shopify:section:load', (event) => initializePocoFaqPage(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recipe-page"] && !Shopify.designMode) return;
  try {
    
  const recipePages = document.querySelectorAll('[data-poco-recipe-page]')

  recipePages.forEach((section) => {
    if (section.dataset.ready === 'true') return
    section.dataset.ready = 'true'

    const dataNode = section.querySelector('[data-poco-recipe-data]')
    if (!dataNode) return

    const recipes = JSON.parse(dataNode.textContent)
    const params = new URLSearchParams(window.location.search)
    const requestedSlug = section.dataset.currentRecipe || params.get('recipe') || recipes[0]?.slug
    const recipe = recipes.find((item) => item.slug === requestedSlug)
    const contentNodes = section.querySelectorAll('.poco-recipe-page__back, .poco-recipe-page__hero, .poco-recipe-page__layout, .poco-recipe-page__tips')
    const notFound = section.querySelector('[data-recipe-not-found]')

    if (!recipe) {
      contentNodes.forEach((node) => { node.hidden = true })
      notFound.hidden = false
      return
    }

    const setText = (selector, value) => {
      const node = section.querySelector(selector)
      if (node) node.textContent = value
    }

    const fillList = (selector, items) => {
      const list = section.querySelector(selector)
      if (!list) return
      list.replaceChildren(...items.map((item) => {
        const listItem = document.createElement('li')
        listItem.textContent = item
        return listItem
      }))
    }

    setText('[data-recipe-category]', recipe.category)
    setText('[data-recipe-title]', recipe.title)
    setText('[data-recipe-summary]', recipe.summary)
    setText('[data-recipe-makes]', recipe.makes)
    setText('[data-recipe-dough]', recipe.dough)
    setText('[data-recipe-proof]', recipe.proof)
    setText('[data-recipe-number]', String(recipes.indexOf(recipe) + 1).padStart(2, '0'))

    if (recipe.imageLarge) {
      const photo = document.createElement('div')
      const image = document.createElement('img')
      photo.className = 'poco-recipe-page__photo'
      image.className = 'poco-recipe-page__image'
      image.src = recipe.imageLarge
      image.alt = recipe.imageAlt || recipe.title
      image.loading = 'eager'
      photo.append(image)
      section.querySelector('.poco-recipe-page__hero-media').append(photo)
      section.querySelector('[data-recipe-number]').hidden = true
    }

    const contributor = section.querySelector('[data-recipe-contributor]')
    if (recipe.contributor) {
      contributor.textContent = recipe.contributor
      contributor.hidden = false
    }

    fillList('[data-recipe-ingredients]', recipe.ingredients)
    fillList('[data-recipe-directions]', recipe.directions)
    fillList('[data-recipe-tips]', recipe.tips)
    const shopLink = section.querySelector('[data-recipe-shop-link]')
    if (shopLink && recipe.buyUrl) shopLink.href = recipe.buyUrl
    if (!section.dataset.currentRecipe) document.title = `${recipe.title} – ${document.title}`
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recipes-index"] && !Shopify.designMode) return;
  try {
    
  const recipeIndexes = document.querySelectorAll('[data-poco-recipes-index]')

  recipeIndexes.forEach((section) => {
    if (section.dataset.ready === 'true') return
    section.dataset.ready = 'true'

    const dataNode = section.querySelector('[data-poco-recipe-data]')
    const search = section.querySelector('[data-recipe-search]')
    const clear = section.querySelector('[data-recipe-clear]')
    const reset = section.querySelector('[data-recipe-reset]')
    const filters = section.querySelector('[data-recipe-filters]')
    const grid = section.querySelector('[data-recipe-grid]')
    const status = section.querySelector('[data-recipe-status]')
    const empty = section.querySelector('[data-recipe-empty]')
    if (!dataNode || !search || !filters || !grid) return

    const recipes = JSON.parse(dataNode.textContent)
    const categories = [...new Set(recipes.map((recipe) => recipe.category))]
    let activeCategory = section.dataset.allLabel

    const createElement = (tag, className, text) => {
      const element = document.createElement(tag)
      if (className) element.className = className
      if (text) element.textContent = text
      return element
    }

    const createFilter = (label) => {
      const button = createElement('button', 'poco-recipes-index__filter', label)
      button.type = 'button'
      button.setAttribute('aria-pressed', String(label === activeCategory))
      button.addEventListener('click', () => {
        activeCategory = label
        render()
      })
      return button
    }

    const renderFilters = () => {
      filters.replaceChildren(createFilter(section.dataset.allLabel), ...categories.map(createFilter))
    }

    const createCard = (recipe, index) => {
      const article = createElement('article', 'poco-recipes-index__card')
      const media = createElement('div', 'poco-recipes-index__card-media')
      if (recipe.image) {
        const image = createElement('img', 'poco-recipes-index__card-image')
        image.src = recipe.image
        image.alt = recipe.imageAlt || ''
        image.loading = 'lazy'
        media.append(image)
      } else {
        media.setAttribute('aria-hidden', 'true')
        media.append(createElement('span', '', String(index + 1).padStart(2, '0')))
      }

      const copy = createElement('div', 'poco-recipes-index__card-copy')
      copy.append(createElement('p', 'poco-recipes-index__category', recipe.category))
      copy.append(createElement('h2', '', recipe.title))
      copy.append(createElement('p', 'poco-recipes-index__summary', recipe.summary))

      const meta = createElement('ul', 'poco-recipes-index__meta')
      meta.append(createElement('li', '', recipe.dough), createElement('li', '', recipe.makes))

      const link = createElement('a', 'poco-recipes-index__link')
      link.href = recipe.url
      link.append(document.createTextNode(section.dataset.readLabel || 'View recipe'))
      const arrow = createElement('span', '', '→')
      arrow.setAttribute('aria-hidden', 'true')
      link.append(arrow)

      copy.append(meta, link)
      article.append(media, copy)
      return article
    }

    const render = () => {
      const query = search.value.trim().toLocaleLowerCase()
      const matches = recipes.filter((recipe) => {
        const inCategory = activeCategory === section.dataset.allLabel || recipe.category === activeCategory
        const searchable = [recipe.title, recipe.category, recipe.summary, ...recipe.ingredients].join(' ').toLocaleLowerCase()
        return inCategory && searchable.includes(query)
      })

      grid.replaceChildren(...matches.map((recipe) => createCard(recipe, recipes.indexOf(recipe))))
      empty.hidden = matches.length > 0
      grid.hidden = matches.length === 0
      clear.hidden = query.length === 0
      status.textContent = matches.length === 1 ? section.dataset.resultSingle : section.dataset.resultPlural.replace('__count__', matches.length)
      filters.querySelectorAll('button').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.textContent === activeCategory))
      })
    }

    search.addEventListener('input', render)
    clear.addEventListener('click', () => {
      search.value = ''
      search.focus()
      render()
    })
    reset.addEventListener('click', () => {
      search.value = ''
      activeCategory = section.dataset.allLabel
      renderFilters()
      render()
      search.focus()
    })

    renderFilters()
    render()
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return

    observer.unobserve(productRecommendationsSection)

    const url = productRecommendationsSection.dataset.url

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div')
        html.innerHTML = text
        const recommendations = html.querySelector('.product-recommendations')

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }

  const productRecommendationsSection = document.querySelector('.product-recommendations')
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' })

  observer.observe(productRecommendationsSection)

  } catch(e) { console.error(e); }
})();
})();
